import React from 'react';
import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import ModalContainer from 'app/components/ModalContainer';

const CustomModalContainer = ({ open, onCloseDialog, children }) => {
  return (
    <ModalContainer
      isShow={open}
      maskClosable={false}
      onCloseDialog={onCloseDialog}
      CloseIcon={<CloseIcon width={12} height={12} />}
      styleSlots={{
        iconWrapperStyle: {
          margin: '-8px 0px 0px 28px',
          width: 12,
          height: 12,
        },
        modalContentStyle: {
          height: 'auto',
          width: 'auto',
          padding: '36px',
          borderRadius: '8px',
        },
        modalStyle: {
          width: 'auto',
        },
        bodyStyle: {
          width: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        },
      }}
    >
      {children}
    </ModalContainer>
  );
};

export default CustomModalContainer;
